import Link from '@/components/client/seo/link'
import { ListicleScoreBadge } from '@/components/client/storyblok/article/listicle-items'
import { ImageWrapper } from '@/components/image'

import type { ListicleCardProps } from './types'

const listicleCardImageSizes = '(min-width: 768px) 290px, calc(100vw - 100px)'

export const ListicleCardImage = ({ card }: ListicleCardProps) => {
  const { name, image, productUrl, scoreDisplay } = card
  return (
    <div className="flex flex-col gap-4 md:col-span-5">
      <div className="relative aspect-[3/2] overflow-hidden rounded-xl bg-slate-100 shadow-inner">
        {productUrl ? (
          <Link href={productUrl} prefetch={false} data-tracking="ignore" className="block h-full w-full">
            {image && (
              <ImageWrapper
                image={image}
                origin="listicle-card"
                loadTime="lazy"
                sizingProps={{ sizes: listicleCardImageSizes }}
                imgProps={{
                  alt: name,
                  className: 'h-full w-full object-cover group-hover:scale-105 transition-transform duration-500',
                }}
              />
            )}
          </Link>
        ) : image ? (
          <ImageWrapper
            image={image}
            origin="listicle-card"
            loadTime="lazy"
            sizingProps={{ sizes: listicleCardImageSizes }}
            imgProps={{ alt: name, className: 'h-full w-full object-cover' }}
          />
        ) : null}

        {scoreDisplay && (
          <div className="absolute top-4 left-4 z-10 drop-shadow-md">
            <ListicleScoreBadge score={scoreDisplay} />
          </div>
        )}
      </div>
    </div>
  )
}
